import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLock, FaUser, FaEye, FaEyeSlash, FaTimes } from 'react-icons/fa';
import './AdminLogin.css';
import firebaseService from '../../services/firebaseService';

function AdminLogin({ onLoginSuccess, onClose }) {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  // Admin credentials
  const ADMIN_CREDENTIALS = {
    email: 'Admin',
    password: '1234554321'
  };

  React.useEffect(() => {
    const isLoggedIn = localStorage.getItem('adminLoggedIn') === 'true';
    if (isLoggedIn) {
      navigate('/admin/orders');
    }
  }, [navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
    setError(''); // Clear error when user types
  };

  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!credentials.email || !credentials.password) {
      setError('Please fill in all fields');
      return;
    }

    setIsLoading(true);

    // Simulate network delay for better UX
    setTimeout(async () => {
      if (credentials.email === ADMIN_CREDENTIALS.email &&
        credentials.password === ADMIN_CREDENTIALS.password) {

        // Log the successful login to Firebase
        await firebaseService.logAdminLogin(credentials.email);

        // Store admin session
        localStorage.setItem('adminLoggedIn', 'true');
        localStorage.setItem('adminLoginTime', new Date().toISOString());

        if (rememberMe) {
          localStorage.setItem('adminRememberMe', 'true');
        }

        setIsLoading(false);
        setIsSuccess(true);

        // Let the success animation play, then call callback
        setTimeout(() => {
          if (onLoginSuccess) {
            onLoginSuccess();
          }
          navigate('/admin/orders');
        }, 1500);

      } else {
        setIsLoading(false);
        setError('Invalid credentials');
      }
    }, 800);
  };

  return (
    <div className="admin-login-container">
      {isSuccess ? (
        <div className="admin-login-card success-card">
          <div className="success-icon-wrapper">
            <svg viewBox="0 0 24 24" fill="none" className="success-icon" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 13L9 17L19 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <h1>Welcome Back</h1>
          <p className="admin-subtitle">Opening Admin Panel...</p>
        </div>
      ) : (
        <div className="admin-login-card">
          <button
            className="admin-login-close-btn"
            onClick={() => navigate('/')}
            aria-label="Close and go back to home"
          >
            <FaTimes />
          </button>

          <div className="admin-login-header">
            <div className="admin-icon-minimal">
              <div className="icon-bar"></div>
              <div className="icon-bar"></div>
              <div className="icon-bar"></div>
            </div>
            <h1>Admin Access</h1>
            <p className="admin-subtitle">Please sign in to continue</p>
          </div>

          <form onSubmit={handleSubmit} className="admin-login-form">
            <div className="form-group">
              <div className="input-wrapper minimal">
                <FaUser className="input-icon" />
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={credentials.email}
                  onChange={handleInputChange}
                  placeholder="Username"
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="form-group">
              <div className="input-wrapper minimal">
                <FaLock className="input-icon" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={credentials.password}
                  onChange={handleInputChange}
                  placeholder="Password"
                  required
                  disabled={isLoading}
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={isLoading}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            {error && (
              <div className="error-message minimal-error">
                {error}
              </div>
            )}

            <button type="submit" className={`login-btn minimal-btn ${isLoading ? 'loading' : ''}`} disabled={isLoading}>
              {isLoading ? 'Signing In...' : 'Sign In'}
            </button>

            <div className="login-options">
              <div className="remember-me minimal-checkbox">
                <input
                  type="checkbox"
                  id="rememberMe"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  disabled={isLoading}
                />
                <label htmlFor="rememberMe">Remember me</label>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default AdminLogin;
